import { render } from "./TestimonialForm.vue?vue&type=template&id=81a9a02c&scoped=true"
import script from "./TestimonialForm.vue?vue&type=script&lang=js"
export * from "./TestimonialForm.vue?vue&type=script&lang=js"

import "./TestimonialForm.vue?vue&type=style&index=0&id=81a9a02c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a9a02c"]])

export default __exports__